import { Globe, Users, UserPlus, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";


const ways = [
  {
    icon: Users,
    title: "Study with Friends",
    description: "Invite classmates into a private room. Small groups of 3–5 are ideal for accountability and collaboration.",
    link: "/study-with-friends/",
  },
  {
    icon: Globe,
    title: "Study with Strangers",
    description: "Join a public room and meet students worldwide. Their dedication can inspire yours.",
    link: "/study-with-strangers/",
  },
  {
    icon: UserPlus,
    title: "Group Study",
    description: "Larger study groups with shared notes, polls and group leaderboards. Study becomes a team sport.",
    link: "/group-study/",
  },
  {
    icon: Heart,
    title: "Study Together Online",
    description: "24/7 rooms across every time zone. You're never alone in your academic journey.",
    link: "/online-study/",
  },
];

export const StudyTogetherSection = () => {
  return (
    <section className="py-24 relative overflow-hidden" aria-labelledby="study-together-title">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-accent/5 to-background" aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <header className="text-center mb-16 animate-fade-in">
            <h2 id="study-together-title" className="font-display text-4xl sm:text-5xl font-bold mb-6">
              <span className="text-gradient">Study Together,</span>{" "}
              <span className="text-foreground">Your Way</span>
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Whether it's friends, strangers, or a global community — find the study environment that works for you.
            </p>
          </header>




          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {ways.map((way, index) => {
              const Icon = way.icon;
              return (
                <Link
                  key={way.title}
                  to={way.link}
                  className="group p-6 rounded-xl bg-card/50 backdrop-blur-sm border border-border/50 hover:border-primary/40 hover:bg-card/80 transition-all duration-300 hover:-translate-y-1 animate-fade-in"
                  style={{ animationDelay: `${0.1 + index * 0.1}s` }}
                >
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary/20 to-secondary/20 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <Icon className="w-6 h-6 text-primary" aria-hidden="true" />
                  </div>
                  <h3 className="font-semibold text-foreground mb-2">{way.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{way.description}</p>
                </Link>
              );
            })}
          </div>

          <div className="text-center">
            <Button size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-8 py-6 text-lg glow-primary transition-all hover:scale-105" asChild>
              <a href="https://app.csw.live" target="_blank" rel="noopener noreferrer">Join a Room Now</a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};